import { LitElement, css } from "lit-element";
import { html } from "lit-html";
import PubSub from "pubsub-js";
import "@ui5/webcomponents/dist/Button.js";
import "@ui5/webcomponents/dist/Dialog.js";
import "@ui5/webcomponents/dist/Panel.js";
import { Router } from "@vaadin/router";

/**
 * Topic not found in ditamap
 * @property {Boolean} dialogOpened - controls whether dialog is mounted to DOM
 */
export class KbDialogNotFound extends LitElement {
  static properties = {
    dialogOpened: { state: true, type: Boolean },
  };

  constructor() {
    super();
    this.dialogOpened = false;
  }

  connectedCallback() {
    super.connectedCallback();
    let token = PubSub.subscribe("message.notfound", this.getData.bind(this));
    if (!token) console.log("An error occurred");
  }

  getData(msg, data) {
    this.show();
  }

  getLangcode() {
   return window.location.pathname.split("/")[2]
  }

  show() {
    this.dialogOpened = true;
  }

  hide() {
    this.dialogOpened = false;
  }

  // Remove dialog from DOM
  reloadPage() {
    Router.go(`/kb/${this.getLangcode()}`);
    this.hide()
  }

  dialogTemplate() {
    return html` <style>
        .long-description {
          padding: 2rem;
          overflow-wrap: anywhere;
          background-color: wheat;
          max-height: 9rem;
          overflow-y: scroll;
          max-width: 54rem;
          box-sizing: border-box;
          width: 100%;
          margin: 0;
          transition: all 0.5s ease-in-out;
        }

        .short-description {
          margin-bottom: 0;
        }

        .icons {
          color: red;
        }

        .content-container {
          margin: 0 0 1rem;
        }

        .heading {
          margin-top: 0;
        }

        ui5-panel {
          --sapGroup_Title_FontSize: 1rem;
        }
      </style>
      <section>
        <div class="content-container">
          <p class="short-description">Topic was not found.</p>
        </div>
        <footer>
          <ui5-button theme="primary" @click=${this.reloadPage}
            >Back to home</ui5-button
          >
        </footer>
      </section>`;
  }

  render() {
    return html`
      <ui5-dialog
        header-text="Error Occured"
        state="Error"
        ?open=${this.dialogOpened}
      >
        ${this.dialogTemplate()}
      </ui5-dialog>
    `;
  }

  static styles = css`
    vaadin-dialog-overlay {
      width: 25rem;
    }
  `;
}

customElements.define("kb-dialog-notfound", KbDialogNotFound);
